import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { Icons, TextField, Stack, Button } from "@curves/ui-base";
import ProductInfo from "@icoach/pos/components/ProductInfo";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { isFunction } from "@util/utils";

// 模擬商品資料
const mockProduct = {
	id: 1,
	sku: "2403XXJAC014",
	name: "Gear岩石灰防潑羽絨外套",
	spec: "XL",
	originalPrice: 999,
	currentPrice: 799,
	quantity: 1,
};

const ProductSettingDialog = React.forwardRef((props, ref) => {
	const { className, open, sourceData = mockProduct, onClose: onCloseProps, refresh } = props;
	if (!open) return null;
	// 內部狀態：管理編輯中的價格與數量
	const [editPrice, setEditPrice] = useState(0);
	const [editQuantity, setEditQuantity] = useState(1);

	// 數量增減輔助函式
	const handleQuantityChange = delta => {
		const newQuantity = editQuantity + delta;
		if (newQuantity >= 1) {
			setEditQuantity(newQuantity);
		}
	};

	const handleOnClose = () => {
		onCloseProps && onCloseProps();
	};

	// 確認修改
	const handleConfirm = () => {
		if (isFunction(refresh)) {
			refresh({
				...sourceData,
				currentPrice: editPrice,
				quantity: editQuantity,
			});
		}
		handleOnClose();
	};

	useEffect(
		() => {
			if (open) {
				setEditPrice(sourceData?.currentPrice || 0);
				setEditQuantity(sourceData?.quantity || 1);
			}
		},
		// eslint-disable-next-line
		[open, sourceData]
	);

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-80rem" }} open={open}>
			<GradientColorHeader onClose={handleOnClose}>編輯商品</GradientColorHeader>
			<DialogContent>
				<Stack className="product-setting-content" justifyContent={"start"} alignItems={"center"} spacing={2}>
					<ProductInfo product={sourceData} />
					<Stack className="price-edit-group" justifyContent={"start"} alignItems={"center"} spacing={1}>
						<Icons.DollarSign className="text-primary" />
						<TextField value={editPrice} onChange={e => setEditPrice(Number(e.target.value))} inputProps={{ min: 0 }} maskType="MONEY" />
					</Stack>
					<Stack className="quantity-edit-group" justifyContent={"start"} alignItems={"center"}>
						<Button size="small" onClick={() => handleQuantityChange(-1)} disabled={editQuantity <= 1}>
							<Icons.Minus className="text-secondary" />
						</Button>
						<TextField value={editQuantity} onChange={e => setEditQuantity(Number(e.target.value))} inputProps={{ min: 1 }} maskType="MONEY" />
						<Button size="small" onClick={() => handleQuantityChange(1)}>
							<Icons.Plus className="text-secondary" />
						</Button>
					</Stack>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button variant="outlined" onClick={handleOnClose}>
					取消
				</Button>
				<Button variant="contained" onClick={handleConfirm}>
					確認
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default ProductSettingDialog;
